export default "https://d1e6s5z4lzmgxx.cloudfront.net/ba82fc54-f5ca-4442-8850-d050cbc89c21/images/unselected-star-icon.png?bfc161cfdbcd6bd870fcc38a4cf390d9";